export const BUTTON_PRESETS = [
  { id: 'classic', label: 'Classic slate', description: 'Dark primary with clean neutrals' },
  { id: 'ocean', label: 'Ocean blue', description: 'Professional blue tones' },
  { id: 'forest', label: 'Forest green', description: 'Natural green palette' },
  { id: 'sunset', label: 'Sunset amber', description: 'Warm orange and amber' },
  { id: 'berry', label: 'Berry purple', description: 'Creative purple accents' },
  { id: 'crimson', label: 'Crimson red', description: 'Bold red highlights' },
  { id: 'midnight', label: 'Midnight navy', description: 'Deep navy and gold' },
  { id: 'teal', label: 'Modern teal', description: 'Fresh teal and cyan' },
  { id: 'charcoal', label: 'Charcoal mono', description: 'Minimal grayscale' },
  { id: 'coral', label: 'Coral blush', description: 'Soft coral and rose' },
];

export const DEFAULT_BRANDING_COLORS = {
  header_bg_color: '#ffffff',
  content_bg_color: '#eef2f7',
  header_text_color: '#0f172a',
  content_text_color: '#0f172a',
  link_color: '#1d4ed8',
};

/**
 * @param {import('./applyPortalBranding.js').PortalBranding | null | undefined} branding
 */
export function resolveBrandingColors(branding) {
  return {
    header_bg_color: branding?.header_bg_color || DEFAULT_BRANDING_COLORS.header_bg_color,
    content_bg_color: branding?.content_bg_color || DEFAULT_BRANDING_COLORS.content_bg_color,
    header_text_color: branding?.header_text_color || DEFAULT_BRANDING_COLORS.header_text_color,
    content_text_color: branding?.content_text_color || DEFAULT_BRANDING_COLORS.content_text_color,
    link_color: branding?.link_color || DEFAULT_BRANDING_COLORS.link_color,
    button_preset: branding?.button_preset || 'classic',
  };
}
